/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ words: NonNullable<unknown>, seconds: NonNullable<unknown> }} Tts_Tool_Words_SecondsInputs */

const en_tts_tool_words_seconds = /** @type {(inputs: Tts_Tool_Words_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.words} words · ${i?.seconds}s`)
};

const es_tts_tool_words_seconds = /** @type {(inputs: Tts_Tool_Words_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.words} palabras · ${i?.seconds}s`)
};

/**
* | output |
* | --- |
* | "{words} words · {seconds}s" |
*
* @param {Tts_Tool_Words_SecondsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_words_seconds = /** @type {((inputs: Tts_Tool_Words_SecondsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Words_SecondsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_words_seconds(inputs)
	return en_tts_tool_words_seconds(inputs)
});